const toErrorMessage = (x: unknown): string => {
    try {
        return JSON.stringify(x)
    } catch {
        const { message } = <never>x
        if (typeof message === "string") return message
        return "Unknown error"
    }
}

export const isError = (x: unknown): x is Error =>
    typeof (x as Error).name === "string" &&
    typeof (x as Error).message === "string" &&
    (!(x as Error).stack || typeof (x as Error).stack === "string")

export const toError = (x: unknown): Error => (isError(x) ? x : new Error(toErrorMessage(x)))
